import { render } from "./UnlockedUserCategories.vue?vue&type=template&id=73041e4a"
import script from "./UnlockedUserCategories.vue?vue&type=script&lang=js"
export * from "./UnlockedUserCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__